import { Reveal } from "./Reveal";
import { VALUE_ITEMS } from "../../data/content";

const EXTRAS = ["Workshops", "Eventos", "Palestras", "Retiros", "Podcasts"];

export const ValueStack = () => (
  <div className="mx-auto max-w-4xl">
    <Reveal>
      <div data-testid="value-stack" className="overflow-hidden rounded-[30px] border border-[#0f1f17]/10 bg-white/70 shadow-[0_40px_80px_-50px_rgba(15,31,23,0.45)] backdrop-blur-xl">
        <div className="flex items-end justify-between gap-4 border-b border-[#0f1f17]/10 px-6 py-6 md:px-10">
          <div>
            <p className="text-[11px] font-semibold uppercase tracking-[0.36em] text-[var(--moss-dark)]">Conteúdo da comunidade</p>
            <h3 className="font-display mt-2 text-2xl text-[var(--forest)] md:text-3xl">Tudo o que você recebe</h3>
          </div>
          <span className="hidden text-[11px] uppercase tracking-[0.24em] text-[#0f1f17]/60 sm:block">Valor individual</span>
        </div>
        <ul>
          {VALUE_ITEMS.map((it, i) => (
            <li
              key={i}
              data-testid={`value-item-${i}`}
              className="group grid grid-cols-[auto_1fr] items-start gap-x-5 gap-y-1 border-b border-[#0f1f17]/[0.07] px-6 py-5 transition-colors duration-500 last:border-b-0 hover:bg-[#7a8f4f]/[0.07] sm:grid-cols-[auto_1fr_auto] sm:items-center md:px-10"
            >
              <span className="font-display text-2xl leading-none text-[#4c6b3a] transition-colors duration-500 group-hover:text-[var(--gold)]">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="text-[15px] leading-snug text-[var(--forest)] md:text-base">{it.text}</span>
              <del className="col-start-2 text-sm text-[#0f1f17]/60 sm:col-start-auto sm:text-right">{it.price}</del>
            </li>
          ))}
        </ul>
        <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-2 bg-[var(--forest)] px-6 py-5 text-[11px] font-semibold uppercase tracking-[0.28em] text-[var(--cream)]/85">
          <span className="text-[var(--gold)]">+ Mais conteúdos</span>
          {EXTRAS.map((e) => (
            <span key={e} className="flex items-center gap-3">
              <span className="h-1 w-1 rounded-full bg-[#d9b45a]/60" />
              {e}
            </span>
          ))}
        </div>
      </div>
    </Reveal>
    <Reveal className="mt-8">
      <div data-testid="total-box" className="relative overflow-hidden rounded-[30px] bg-gradient-to-br from-[#9a433c] to-[#6f2c27] px-6 py-9 text-center text-[var(--cream)] md:px-12">
        <div className="grain absolute inset-0" />
        <p className="relative text-[11px] font-semibold uppercase tracking-[0.36em] text-[var(--cream)]/80">Você pagaria o total de</p>
        <p className="font-display relative mt-2 text-5xl md:text-6xl">
          R$ 1.594,00 <span className="text-lg text-[var(--cream)]/75 md:text-xl">(por ano)</span>
        </p>
        <p className="relative mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-[var(--cream)]/90 md:text-base">
          Calma, o preço atual é este, mas vai sair MUITO mais BARATO que isso para o ACESSO VITALÍCIO (OFERTA DE BLACK FRIDAY) veja abaixo.
        </p>
      </div>
    </Reveal>
  </div>
);
